import React from 'react';
import { Phone, Mail } from 'lucide-react';

const DakoContactSection = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Kontaktujte nás
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Rádi zodpovíme vaše dotazy a upřesníme nabídku
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            {/* Catering / Inventář */}
            <div className="bg-gradient-to-br from-orange-500 to-red-500 rounded-3xl shadow-2xl overflow-hidden">
              <div className="p-8 text-white">
                <div className="text-center mb-6">
                  <div className="w-32 h-32 rounded-2xl mx-auto mb-4 border-4 border-white shadow-lg overflow-hidden">
                    <img 
                      src="https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/qicecfy5_Jakub%20Foto.png"
                      alt="Jakub Vodárek"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h3 className="text-2xl font-bold mb-1">Jakub Vodárek</h3>
                  <p className="text-orange-100">Catering / Inventář</p>
                </div>
                
                <div className="space-y-4">
                  <a
                    href="tel:774750456"
                    className="flex items-center space-x-4 bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-xl p-4 transition-all duration-300 border border-white/20"
                  >
                    <div className="bg-white/20 rounded-lg p-3">
                      <Phone className="w-6 h-6" />
                    </div>
                    <div>
                      <div className="text-sm text-orange-100">Telefon</div>
                      <div className="font-bold text-lg">774 750 456</div>
                    </div>
                  </a>
                  
                  <a
                    href="mailto:info@vseproakci.cz"
                    className="flex items-center space-x-4 bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-xl p-4 transition-all duration-300 border border-white/20"
                  >
                    <div className="bg-white/20 rounded-lg p-3">
                      <Mail className="w-6 h-6" />
                    </div>
                    <div>
                      <div className="text-sm text-orange-100">Email</div>
                      <div className="font-bold text-lg">info@vseproakci.cz</div>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            {/* Produkce / Program */}
            <div className="bg-gradient-to-br from-purple-500 to-blue-500 rounded-3xl shadow-2xl overflow-hidden">
              <div className="p-8 text-white">
                <div className="text-center mb-6">
                  <div className="w-32 h-32 rounded-2xl mx-auto mb-4 border-4 border-white shadow-lg overflow-hidden">
                    <img 
                      src="https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/69pzrlsa_monika%20FOTO.png"
                      alt="Monika Ondruchová"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h3 className="text-2xl font-bold mb-1">Monika Ondruchová</h3>
                  <p className="text-purple-100">Produkce / Program</p>
                </div>
                
                <div className="space-y-4">
                  <a
                    href="tel:773550880"
                    className="flex items-center space-x-4 bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-xl p-4 transition-all duration-300 border border-white/20"
                  >
                    <div className="bg-white/20 rounded-lg p-3">
                      <Phone className="w-6 h-6" />
                    </div>
                    <div>
                      <div className="text-sm text-purple-100">Telefon</div>
                      <div className="font-bold text-lg">773 550 880</div>
                    </div>
                  </a>
                  
                  <a
                    href="mailto:monika@vseproakci.cz"
                    className="flex items-center space-x-4 bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-xl p-4 transition-all duration-300 border border-white/20"
                  >
                    <div className="bg-white/20 rounded-lg p-3">
                      <Mail className="w-6 h-6" />
                    </div>
                    <div>
                      <div className="text-sm text-purple-100">Email</div>
                      <div className="font-bold text-lg">monika@vseproakci.cz</div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Client References */}
          <div className="mt-16 text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-8">
              Důvěřují nám
            </h3>
            <div className="flex flex-wrap items-center justify-center gap-12">
              <div className="text-gray-400 font-semibold text-lg">Lapp Group</div>
              <div className="text-gray-400 font-semibold text-lg">Fatra a.s.</div>
              <div className="text-gray-400 font-semibold text-lg">Česká televize</div>
              <div className="text-gray-400 font-semibold text-lg">Amazon</div>
              <div className="text-gray-400 font-semibold text-lg">Barum Continental</div>
              <div className="text-gray-400 font-semibold text-lg">Plzeňský Prazdroj</div>
              <div className="text-gray-400 font-semibold text-lg">Greiner Packaging</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DakoContactSection;
